import axios from 'axios';
import { API_URL as BASE_API_URL } from '../config/apiConfig';

const API_URL = `${BASE_API_URL}/api`;

const auditService = {
    searchLogs: async (params) => {
        try {
            const response = await axios.get(`${API_URL}/audit/search`, {
                params,
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`
                }
            });
            return response.data;
        } catch (error) {
            console.error('Error searching audit logs:', error);
            throw error;
        }
    },

    exportLogs: async (params) => {
        try {
            const response = await axios.get(`${API_URL}/audit/export`, {
                params,
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`
                },
                responseType: 'blob'
            });
            
            // Create download link
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'audit_logs.json');
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error exporting audit logs:', error);
            throw error;
        }
    },

    getStorageMetrics: async () => {
        try {
            const response = await axios.get(`${API_URL}/audit/metrics`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`
                }
            });
            return response.data;
        } catch (error) {
            console.error('Error getting storage metrics:', error);
            throw error;
        }
    }
};

export default auditService;
